import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Produkte from "@/pages/produkte/page";
import Unternehmen from "@/pages/unternehmen/page";
import Kontakt from "@/pages/kontakt/page";
import Impressum from "@/pages/impressum/page";
import Datenschutz from "@/pages/datenschutz/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "produkte", element: <Produkte /> },
      { path: "unternehmen", element: <Unternehmen /> },
      { path: "kontakt", element: <Kontakt /> },
      { path: "impressum", element: <Impressum /> },
      { path: "datenschutz", element: <Datenschutz /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;